// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".node_modules-\\@vibrent-electryon-dist-components-spinner-styles__spinner-wrapper--1SMXs_-_{text-align:center}.node_modules-\\@vibrent-electryon-dist-components-spinner-styles__spinner-wrapper--1SMXs_-_ .spinner-container{margin:0 auto}.node_modules-\\@vibrent-electryon-dist-components-spinner-styles__spinner-wrapper--1SMXs_-_ .spinner-container .react-spinner-material{margin:0 auto}.node_modules-\\@vibrent-electryon-dist-components-spinner-styles__spinner-wrapper--1SMXs_-_ .spinner-container .spinner-label{font-size:24px;padding-top:8px;display:block}", ""]);
// Exports
exports.locals = {
	"spinner-wrapper": "node_modules-@vibrent-electryon-dist-components-spinner-styles__spinner-wrapper--1SMXs_-_"
};
module.exports = exports;
